export default __webpack_public_path__ + "static/drg-logo-9fb0b0a2704ab42e1ff40ca29cd31ad5.png";